console.log("horario")

jQuery_T4NT(document).ready(function($) {
  console.log("from custom code schedule");
  console.log(currentProduct);

  var settingsRest =[
    '0500-2000',
    '0500-2000','0500-2030',
    '0500-2030','0500-2030',
    '0500-2000','0500-2130',
    '"Este producto no está disponible en este horario. \n\u003cbr\u003e\nHaz tu pedio o programa tu domicilio:\n\u003cbr\u003e\nLunes a jueves 4:00 a.m. - 8:15 p.m.\nViernes y sábados 4:00 a.m. - 9:15 p.m.\nDomingos y festivos 4:00 a.m. - 7:45 p.m."'
  ];
  var settingsLiq =[
    '',
    '','',
    '','',
    '','',
    '""'
  ];
  var cartSelector = "#cart-form_ppr";
  var currentDate = new Date();
  var day = currentDate.getDay(); 
  var product = currentProduct;
  var message = "";
  var dates= "";  
  var tags = false;

  for(var i=0; i< product.tags.length; i++){
    var tag = product.tags[i];

    if(tag =="Bar"){
      dates = settingsLiq[day];
      message = settingsLiq[7];   
      tags = true;
    }   
    if(tag =="Restaurante"){
      dates = dates == ""? settingsRest[day] : dates + "," + settingsRest[day];
      message = settingsRest[7];  
      tags = true;
    }
  }

  console.log(message);
  
  if(dates != null && dates != ""){ 
    var show = false;
    dates = dates.split(",");

    for(var i=0; i< dates.length; i++){
      show = show || (validate(dates[i]));
    }

    if(!(show)){
      console.log(message);
      $("#close-store-message").html(message.replace(/"/g, ''));
      $("#close-store-message").show();
      $("#infiniteoptions-container").hide();

    }
  }
  else if(!tags){
    $(cartSelector).show();
    $(".dynamic-buttons").show();
  }
  else{
    $("#close-store-message").html(message.replace(/"/g, ''));
    $("#close-store-message").show();
    $("#infiniteoptions-container").hide();
  }

  console.log(dates);

  function validate(dates){
    if(dates != null && dates != ""){        
      var initial = parseInt(dates.split("-")[0]);
      var final = parseInt(dates.split("-")[1]);
      var current =parseInt(currentDate.getHours() +""+ checkTime(currentDate.getMinutes()));

      if( current >=initial && current < final ){
        $(cartSelector).show();
        $(".dynamic-buttons").show();

        return true;
      }     
    }

    return false;
  };

  function checkTime(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }
});